package koala

/** The site's SVG icons. */
object SvgFile : FileSet<Svg>() {
    val Archive = add("archive.svg")
    val ArrowLeft = add("arrow-left.svg")
    val ArrowRight = add("arrow-right.svg")
    val ArrowUp = add("arrow-up.svg")
    val ArrowsSort = add("arrows-sort.svg")
    val Aperture = add("aperture.svg")
    val Backspace = add("backspace.svg")
    val Book = add("book.svg")
    val BookLarge = add("book-large.svg")
    val Boost = add("boost.svg")
    val BoostFilled = add("boost-filled.svg")
    val Bulb = add("bulb.svg")
    val Bus = add("bus.svg")
    val Calendar = add("calendar.svg")
    val CalendarLarge = add("calendar-large.svg")
    val CalendarMinus = add("calendar-minus.svg")
    val CalendarPlus = add("calendar-plus.svg")
    val CaretLeft = add("caret-left.svg")
    val CaretUp = add("caret-up.svg")
    val Chart = add("chart.svg")
    val ChartLarge = add("chart-large.svg")
    val Check = add("check.svg")
    val ChevronUp = add("chevron-up.svg")
    val ChevronDown = add("chevron-down.svg")
    val City = add("city.svg")
    val CityLarge = add("city-large.svg")
    val Clock = add("clock.svg")
    val Crosshairs = add("crosshairs.svg")
    val Dashboard = add("dashboard.svg")
    val Database = add("database.svg")
    val DatabaseArrow = add("database-arrow.svg")
    val DatabasePlus = add("database-plus.svg")
    val DatabaseMinus = add("database-minus.svg")
    val Directions = add("directions.svg")
    val Dots = add("dots.svg")
    val DotsVertical = add("dots-vertical.svg")
    val Earth = add("earth.svg")
    val Edit = add("edit.svg")
    val ExpandBelow = add("expand-below.svg")
    val Eye = add("eye.svg")
    val EyeClosed = add("eye-closed.svg")
    val EyeMinus = add("eye-minus.svg")
    val EyeOff = add("eye-off.svg")
    val EyePlus = add("eye-plus.svg")
    val Flame = add("flame.svg")
    val FlameLarge = add("flame-large.svg")
    val Focus = add("focus.svg")
    val Food = add("food.svg")
    val FrameEye = add("frame-eye.svg")
    val GearLarge = add("gear-large.svg")
    val GearSmall = add("gear-small.svg")
    val Github = add("github.svg")
    val Guitar = add("guitar.svg")
    val Helm = add("helm.svg")
    val HeartHandshake = add("heart-handshake.svg")
    val Home = add("home.svg")
    val HomeLarge = add("home-large.svg")
    val Info = add("info.svg")
    val LayoutGrid = add("layout-grid.svg")
    val LayoutMinimal = add("layout-minimal.svg")
    val LayoutRow = add("layout-row.svg")
    val Light = add("light.svg")
    val LightFilled = add("light-filled.svg")
    val Link = add("link.svg")
    val LoaderSmall = add("loader-small.svg")
    val LogoFlame = add("logo-flame.svg")
    val LogoText = add("logo-text.svg")
    val LogoTextStreet = add("logo-text-street.svg")
    val LogoTextLight = add("logo-text-light.svg")
    val Magic = add("magic.svg")
    val Mail = add("mail.svg")
    val MailLarge = add("mail-large.svg")
    val MapPin = add("map-pin.svg")
    val MapPinLarge = add("map-pin-large.svg")
    val MapWithPin = add("map-pin.svg")
    val Meet = add("social.svg")
    val Menu = add("menu.svg")
    val Message = add("message.svg")
    val MessageMinus = add("message-minus.svg")
    val MessagePlus = add("message-plus.svg")
    val MessageSmall = add("message-small.svg")
    val Minus = add("minus.svg")
    val Moon = add("moon.svg")
    val PanelLeft = add("panel-left.svg")
    val PanelRight = add("panel-right.svg")
    val Plus = add("plus.svg")
    val PlusAbove = add("plus-above.svg")
    val Question = add("question.svg")
    val QuestionLarge = add("question-large.svg")
    val Rays = add("rays.svg")
    val Ruler = add("ruler.svg")
    val RulerMeasure = add("ruler-measure.svg")
    val Satellite = add("satellite.svg")
    val Search = add("search.svg")
    val ShootingStar = add("shooting-star.svg")
    val SignOut = add("sign-out.svg")
    val Someone = add("someone.svg")
    val SomeoneSmall = add("someone-small.svg")
    val StarFilled = add("star-filled.svg")
    val StarOff = add("star-off.svg")
    val Star = add("star-outline.svg")
    val Sun = add("sun.svg")
    val TicketSmall = add("ticket-small.svg")
    val Train = add("train.svg")
    val TransitStop = add("transit-stop.svg")
    val Trash = add("trash.svg")
    val UserSmall = add("user-small.svg")
    val User = add("user.svg")
    val X = add("x.svg")
    val XLarge = add("x-large.svg")

    // animations
    val CircleLoop = add("circle-loop-beta.svg")
    val LineParticleLoop = add("line-particle-loop.svg")

    // filigree
    val CircularFiligree = add("circular-filigree.svg")
    val CircularFiligreeAnimated = add("circular-filigree-animated.svg")
    val Plant = add("filigree-plant.svg")
}